import React from "react";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import type { ColDef, RowValueChangedEvent } from "ag-grid-community"; // Column Definition Interface

interface IDataTableProps<T> {
  data: T[];
  columnDefs: ColDef[];
  onRowValueChanged?: (event: RowValueChangedEvent) => void;
}

function DataTable<T>({ data, columnDefs, onRowValueChanged }: IDataTableProps<T>) {
  return (
    <div className="ag-theme-quartz imm_admin__data_table">
      <AgGridReact
        className=""
        rowData={data}
        columnDefs={columnDefs}
        pagination={true}
        paginationPageSize={100}
        paginationPageSizeSelector={[100, 200]}
        onRowValueChanged={onRowValueChanged}
        stopEditingWhenCellsLoseFocus={true}
        editType={'fullRow'}
      />
    </div>
  );
};

export default DataTable;
